<template>
    <div class="modal-container">
      <!-- Modal -->
      <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" @click="$emit('close')">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Backdrop -->
      <div class="modal-backdrop fade show"></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Modal'
  }
  </script>
  
  <style scoped>
  .modal-container {
    position: fixed;
    top: 0;
    left: 0;
    max-width: 0px;
    height: 100%;
    z-index: 1050;
  }
  
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 1052; /* Higher than backdrop */
  }
  
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1051;
  }
  
  .modal-content {
    position: relative;
    z-index: 1053; /* Higher than modal */
  }
  </style>